module.exports = __webpack_public_path__ + "static/media/008.ff980d35.jpg";